import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = 'https://www.testometer.in:8084/api';

const AdminSettings = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleInitializeDefaultAdmin = async () => {
    if (window.confirm('This will create a default admin account if none exists. Continue?')) {
      try {
        setLoading(true);
        setError('');
        setMessage('');
        
        const response = await axios.post(`${API_BASE_URL}/admin/initialize`);
        setMessage(response.data.message || 'Default admin initialized successfully');
      } catch (error) {
        console.error('Error initializing default admin:', error);
        setError(error.response?.data?.error || 'Error initializing default admin');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleClearCache = () => {
    if (window.confirm('This will clear all cached data. Continue?')) {
      setMessage('Cache cleared successfully');
      // In a real application, you would call an API endpoint to clear cache
    }
  };

  const handleSystemBackup = () => {
    if (window.confirm('This will create a system backup. Continue?')) {
      setMessage('System backup initiated successfully');
      // In a real application, you would call an API endpoint to create backup
    }
  };

  return (
    <div className="admin-settings">
      <div className="management-header">
        <div>
          <h2>System Settings</h2>
          <p>Manage system configuration and maintenance</p>
        </div>
      </div>

      {/* Messages */}
      {message && (
        <div className="success-message">
          {message}
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="settings-grid">
        {/* System Administration */}
        <div className="settings-section">
          <h3>🔧 System Administration</h3>
          <div className="settings-actions">
            <div className="setting-item">
              <div className="setting-info">
                <h4>Initialize Default Admin</h4>
                <p>Create a default admin account if none exists</p>
              </div>
              <button
                onClick={handleInitializeDefaultAdmin}
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Initializing...' : 'Initialize'}
              </button>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h4>Clear Cache</h4>
                <p>Clear all cached data to free up memory</p>
              </div>
              <button
                onClick={handleClearCache}
                className="btn btn-secondary"
              >
                Clear Cache
              </button>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h4>System Backup</h4>
                <p>Create a complete system backup</p>
              </div>
              <button
                onClick={handleSystemBackup}
                className="btn btn-success"
              >
                Create Backup
              </button>
            </div>
          </div>
        </div>

        {/* System Information */}
        <div className="settings-section">
          <h3>ℹ️ System Information</h3>
          <div className="system-info">
            <div className="info-item">
              <span className="info-label">System Version:</span>
              <span className="info-value">1.0.0</span>
            </div>
            <div className="info-item">
              <span className="info-label">Database:</span>
              <span className="info-value">MySQL 8.0</span>
            </div>
            <div className="info-item">
              <span className="info-label">Backend:</span>
              <span className="info-value">Spring Boot 3.2.0</span>
            </div>
            <div className="info-item">
              <span className="info-label">Frontend:</span>
              <span className="info-value">React 18</span>
            </div>
            <div className="info-item">
              <span className="info-label">Last Updated:</span>
              <span className="info-value">{new Date().toLocaleDateString()}</span>
            </div>
          </div>
        </div>

        {/* Security Settings */}
        <div className="settings-section">
          <h3>🔒 Security Settings</h3>
          <div className="settings-actions">
            <div className="setting-item">
              <div className="setting-info">
                <h4>Session Timeout</h4>
                <p>Configure automatic logout after inactivity</p>
              </div>
              <select className="input-field" defaultValue="24">
                <option value="1">1 hour</option>
                <option value="8">8 hours</option>
                <option value="24">24 hours</option>
                <option value="168">1 week</option>
              </select>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h4>Password Policy</h4>
                <p>Configure password requirements</p>
              </div>
              <button className="btn btn-secondary">
                Configure
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings; 